import { aadharPlaceholder, document, pancard } from "../../asset";
import DocumentUpload from "../../components/common/DocumetUpload";
import SubHeadings from "../../components/SubHeadings";
import { useEditMode } from "../../context/EditModeContext";
import { Staff } from "../../types/staff";

interface PersonalInformationProps {
  staff?: Staff;
  onChange: (data: Partial<Staff>) => void;
}

export default function DocumentInfo({
  staff,
  onChange,
}: PersonalInformationProps) {
  const { isEditing } = useEditMode();

  return (
    <div className="md:px-9 px-4 pb-20">
      <div className="flex flex-col gap-7 w-full py-7">
        <SubHeadings text="Document Details" />
        <div className="grid lg:grid-cols-3 max-w-lg mx-auto lg:max-w-7xl lg:w-full h-full gap-y-24 lg:gap-16">
          <DocumentUpload
            label="Aadhaar Card"
            value={staff?.aadharCardUrl}  
            onUploadComplete={(url) => {
              onChange({ aadharCardUrl: url });
            }}
            placeholderImage={aadharPlaceholder}
            borderStyle="solid"
            buttonWidth="fit"
            buttonAlign="right"
            buttonText="Upload"
            className="w-full"
            disabled={!isEditing}
          />
          <DocumentUpload
            label="PAN card"
            value={staff?.panCardUrl}  
            onUploadComplete={(url) => {
              onChange({ panCardUrl: url });
            }}
            placeholderImage={pancard}
            borderStyle="solid"
            buttonWidth="fit"
            buttonAlign="right"
            buttonText="Upload"
            className="w-full"
            disabled={!isEditing}
          />
          <DocumentUpload
            label="Highest qualification documents"
            onUploadComplete={(url) => {
              onChange({ qualificationDocUrl: url });
            }}
            value={staff?.qualificationDocUrl}  
            placeholderImage={document}
            borderStyle="solid"
            buttonWidth="fit"
            buttonAlign="right"
            buttonText="Upload"
            className="w-full"
            disabled={!isEditing}
          />
        </div>
      </div>
    </div>
  );
}
